import { render } from "./Services.vue?vue&type=template&id=6e3577b6&scoped=true"
import script from "./Services.vue?vue&type=script&lang=js"
export * from "./Services.vue?vue&type=script&lang=js"

import "./Services.vue?vue&type=style&index=0&id=6e3577b6&scoped=true&lang=css"

import exportComponent from "c:\\dev\\davca-cm\\davca-cm\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e3577b6"]])

export default __exports__